import { 
	SET_USER_ID_EMAIL_MAP,
	SET_PERMISSION,
	GET_PERMISSIONS,
	SET_ACTIVE_PERMISSION,
	EDIT_PERMISSION,
	REMOVE_PERMISSION
} from './types';

import {
	_getPermissions,
	_postAdminPermission,
	_deletePermission
} from '../../services'

export const setUserIdEmailMap = ( userIdEmailMap ) => {
	return {
		type: SET_USER_ID_EMAIL_MAP,
		userIdEmailMap
	}
}

export const setActivePermission = (permission) => {
	return {
		type: SET_ACTIVE_PERMISSION,
		permission
	}
}

export const setPermission = ({title, pages, permissionId = false}) => {

	return {
		type: permissionId?EDIT_PERMISSION:SET_PERMISSION,
		payload: _postAdminPermission({title, pages, permissionId})
	}
}

export const getPermissions = () => {
	return {
		type: GET_PERMISSIONS,
		payload: _getPermissions()
	}
}

export const removePermission = (permissionId) => {
	return {
		type: REMOVE_PERMISSION,
		payload: _deletePermission(permissionId)
	}
}



// WEBPACK FOOTER //
// ./src/components/admin/actions.js